/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DiscountCategoryResponse } from './DiscountCategoryResponse';
import type { DiscountClientResponse } from './DiscountClientResponse';
export type DiscountWithClientResponse = {
    validUntil: string | null;
    client: DiscountClientResponse | null;
    id: number;
    therapistId: number;
    clientId: number;
    categoryId: number;
    discountType: DiscountWithClientResponse.discountType;
    value: string;
    isActive: boolean;
    note: string | null;
    createdAt: string;
    category: DiscountCategoryResponse | null;
};
export namespace DiscountWithClientResponse {
    export enum discountType {
        PERCENTAGE = 'percentage',
        FIXED = 'fixed',
    }
}

